<section id="faq" class="faq section">
  <div class="faq__inner container">
    <div class="faq__list-wrapper">
      <h2 class="faq__title title-dark">{{ title() }}</h2>

      <div class="faq__list">
        @for (faq of faqs(); track faq.question; let i = $index) {
          <article class="faq__item" [class.faq__item--open]="openedIndex === i">
            <h2 class="faq__question">
              <button
                class="faq__trigger"
                type="button"
                [id]="'faq-trigger-' + i"
                [attr.aria-expanded]="openedIndex === i"
                [attr.aria-controls]="'faq-panel-' + i"
                (click)="toggleAccordion(i)"
              >
                <span class="faq__question-title title-small">{{ faq.question }}</span>
                <span class="faq__icon" aria-hidden="true"></span>
              </button>
            </h2>

            <div
              class="faq__panel"
              [id]="'faq-panel-' + i"
              role="region"
              [attr.aria-labelledby]="'faq-trigger-' + i"
              [attr.aria-hidden]="openedIndex !== i"
            >
              <div class="faq__panel-inner type-body-b3">
                <p [innerHTML]="faq.answer | safeHtml"></p>
              </div>
            </div>
          </article>
        }
      </div>

      @if (note()) {
        <p class="faq__note type-caption-c3" [innerHTML]="note() | safeHtml"></p>
      }
    </div>
  </div>
</section>
